/* eslint import/no-extraneous-dependencies: 0 */
/* eslint object-shorthand: 0 */
/* eslint func-names: 0 */
/* eslint max-len: 0 */
import * as Blockly from 'blockly';
import colors from '../utils/colors';
import options from '../utils/blocksOptions';

Blockly.Blocks.createc_floralis_luminaria_zona4 = {
  init: function () {
    this.setColour(colors.COLOUR_SALIDAS);
    this.appendDummyInput('image')
      .appendField(new Blockly.FieldImage(`${options.imgBase}/blocks/createc/LuzCalle.png`, options.blockWidth, options.blockHeight))
      .appendField(Blockly.Msg.LANG_SALIDAS_RAYITA);
    this.appendDummyInput().setAlign(Blockly.inputs.Align.RIGHT)
      .appendField(new Blockly.FieldDropdown([
        [Blockly.Msg.LANG_SALIDAS_LED_ON, 'HIGH'],
        [Blockly.Msg.LANG_SALIDAS_LED_OFF, 'LOW'],
      ]), 'STAT');
    this.appendDummyInput().appendField(Blockly.Msg.LANG_LUMINARIA_ZONA4).setAlign(Blockly.inputs.Align.RIGHT);
    this.setInputsInline(true);
    this.setPreviousStatement(true, null);
    this.setNextStatement(true, null);
    this.setTooltip(Blockly.Msg.LANG_LUMINARIA_ZONA4_TOOLTIP);
  },
};

Blockly.Blocks.createc_floralis_lights = {
  init: function () {
    this.setColour(colors.COLOUR_SALIDAS);
    this.appendDummyInput()
      .appendField(new Blockly.FieldImage(`${options.imgBase}/blocks/createc/Flor.png`, options.blockWidth, options.blockHeight))
      .appendField(Blockly.Msg.LANG_SALIDAS_RAYITA);
    this.appendValueInput('COLOUR')
      .appendField(Blockly.Msg.LANG_BHOOT_LED_NEOPIXEL2)
      .setAlign(Blockly.inputs.Align.RIGHT);
    this.appendDummyInput('').appendField(Blockly.Msg.LANG_FLORALIS_LIGHTS).setAlign(Blockly.inputs.Align.RIGHT);
    this.setInputsInline(true);
    this.setPreviousStatement(true, null);
    this.setNextStatement(true, null);
    this.setTooltip(Blockly.Msg.LANG_FLORALIS_LIGHTS_TOOLTIP);
  },
};

Blockly.Blocks.createc_floralis_lights_off = {
  init: function () {
    this.setColour(colors.COLOUR_SALIDAS);
    this.appendDummyInput('')
      .appendField(new Blockly.FieldImage(`${options.imgBase}/blocks/createc/Flor.png`, options.blockWidth, options.blockHeight))
      .appendField(Blockly.Msg.LANG_SALIDAS_RAYITA)
      .appendField(Blockly.Msg.LANG_FLORALIS_LIGHTS_OFF);
    this.setPreviousStatement(true, null);
    this.setNextStatement(true, null);
    this.setTooltip(Blockly.Msg.LANG_FLORALIS_LIGHTS_OFF_TOOLTIP);
  },
};

Blockly.Blocks.createc_floralis_reflector = {
  init: function () {
    this.setColour(colors.COLOUR_SALIDAS);
    this.appendDummyInput()
      .appendField(new Blockly.FieldImage(`${options.imgBase}/blocks/createc/Reflector.png`, options.blockWidth, options.blockHeight))
      .appendField(Blockly.Msg.LANG_SALIDAS_RAYITA);
    this.appendValueInput('COLOUR')
      .appendField(Blockly.Msg.LANG_BHOOT_LED_NEOPIXEL2)
      .setAlign(Blockly.inputs.Align.RIGHT);
    this.appendDummyInput('').appendField(Blockly.Msg.LANG_FLORALIS_REFLECTOR).setAlign(Blockly.inputs.Align.RIGHT);
    this.setInputsInline(true);
    this.setPreviousStatement(true, null);
    this.setNextStatement(true, null);
    this.setTooltip(Blockly.Msg.LANG_FLORALIS_REFLECTOR_TOOLTIP);
  },
};

Blockly.Blocks.createc_floralis_reflector_off = {
  init: function () {
    this.setColour(colors.COLOUR_SALIDAS);
    this.appendDummyInput('')
      .appendField(new Blockly.FieldImage(`${options.imgBase}/blocks/createc/Reflector.png`, options.blockWidth, options.blockHeight))
      .appendField(Blockly.Msg.LANG_SALIDAS_RAYITA)
      .appendField(Blockly.Msg.LANG_FLORALIS_REFLECTOR_OFF);
    this.setPreviousStatement(true, null);
    this.setNextStatement(true, null);
    this.setTooltip(Blockly.Msg.LANG_FLORALIS_REFLECTOR_OFF_TOOLTIP);
  },
};

Blockly.Blocks.createc_floralis_restore_petal = {
  init: function () {
    this.setColour(colors.COLOUR_SERVO);
    this.appendDummyInput('')
      .appendField(new Blockly.FieldImage(`${options.imgBase}/blocks/createc/Flor.png`, options.blockWidth, options.blockHeight))
      .appendField(Blockly.Msg.LANG_SALIDAS_RAYITA)
      .appendField(Blockly.Msg.LANG_RESTORE_PETAL);
    this.setPreviousStatement(true, null);
    this.setNextStatement(true, null);
    this.setTooltip(Blockly.Msg.LANG_RESTORE_PETAL_TOOLTIP);
  },
};

Blockly.Blocks.createc_floralis_open_petal = {
  init: function () {
    this.setColour(colors.COLOUR_SERVO);
    this.appendDummyInput('image')
      .appendField(new Blockly.FieldImage(`${options.imgBase}/blocks/createc/Flor.png`, options.blockWidth, options.blockHeight))
      .appendField(Blockly.Msg.LANG_SALIDAS_RAYITA);
    this.appendDummyInput().setAlign(Blockly.inputs.Align.RIGHT)
      .appendField(new Blockly.FieldDropdown([
        [Blockly.Msg.LANG_FLORALIS_ACTION_OPEN, 'HIGH'],
        [Blockly.Msg.LANG_FLORALIS_ACTION_CLOSE, 'LOW'],
      ]), 'STAT');
    this.appendDummyInput().appendField(Blockly.Msg.LANG_FLORALIS_OPEN_PETAL).setAlign(Blockly.inputs.Align.RIGHT);
    this.setInputsInline(true);
    this.setPreviousStatement(true, null);
    this.setNextStatement(true, null);
    this.setTooltip(Blockly.Msg.LANG_FLORALIS_OPEN_PETAL_TOOLTIP);
  },
};
